import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Hero } from './components/Hero';
import { Algorithm } from './components/Algorithm';
import { HowWeWork } from './components/HowWeWork';
import { DawsonStory } from './components/DawsonStory';
import { ROICalculator } from './components/ROICalculator';
import { Proof } from './components/Proof';
import { StartWorking } from './components/StartWorking';
import { Footer } from './components/Footer';
export function App() {
  return <>
      <Helmet data-id="element-0">
        <title data-id="element-1">Dilbert Ratio Group - AI Automation That Drives Profit</title>
        <meta name="description" content="AI automation partners that challenge, delete, simplify, and accelerate before we automate. Building systems that drive profit, not just features." data-id="element-2" />
        <meta property="og:title" content="Dilbert Ratio Group - AI Automation That Drives Profit" data-id="element-3" />
        <meta property="og:description" content="AI automation partners that challenge, delete, simplify, and accelerate before we automate. Building systems that drive profit, not just features." data-id="element-4" />
        <meta property="og:type" content="website" data-id="element-5" />
        <meta name="twitter:card" content="summary_large_image" data-id="element-6" />
        <meta name="twitter:title" content="Dilbert Ratio Group - AI Automation That Drives Profit" data-id="element-7" />
        <meta name="twitter:description" content="AI automation partners that challenge, delete, simplify, and accelerate before we automate. Building systems that drive profit, not just features." data-id="element-8" />
      </Helmet>
      <div className="w-full min-h-screen bg-black text-amber-50" data-id="element-9">
        <Hero data-id="element-10" />
        <Algorithm data-id="element-11" />
        <HowWeWork data-id="element-12" />
        <DawsonStory data-id="element-13" />
        <ROICalculator data-id="element-14" />
        <Proof data-id="element-15" />
        <StartWorking data-id="element-16" />
        <Footer data-id="element-17" />
      </div>
    </>;
}